import { usePlausible } from 'next-plausible';
import { usePostHog } from 'posthog-js/react';

import type { LinkField } from '@/types';

import { segment } from './segmentAnalytics';

import { CTA } from '.';

export function useBookDemoTrackingHandler(link: LinkField) {
    const plausible = usePlausible();
    const posthog = usePostHog();

    function handleClick() {
        const { label, type } = link;

        if (type === 'book-demo') {
            posthog.capture(CTA.BOOK_DEMO_CLICKED, { label });
            segment.track(CTA.BOOK_DEMO_CLICKED, { label });
            plausible(CTA.BOOK_DEMO_CLICKED, {
                props: {
                    label: label,
                },
            });
        }
    }

    return handleClick;
}
